import React, { useState, useEffect } from "react";

const CustomSelect = ({options, value, title, func}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  useEffect(() => {
    func.handleChangePage(selectedOption);  
  }, [selectedOption]);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectOption = (option) => {
    setSelectedOption(option);
    setIsOpen(false); 
  };

  const closeDropdown = (e) => {
    if (!e.target.closest(".custom-select")) {
      setIsOpen(false);
    }
  };

  
  useEffect(() => {
    window.addEventListener("click", closeDropdown);

    return () => {
      window.removeEventListener("click", closeDropdown);
    };
  }, []);

  return (
    <div className="custom-select">
      <div className="select-selected" onClick={toggleDropdown} data-cy={"table-select-pagination"}>
        <>
        <p className="title">{title} {selectedOption}</p>
        </>
        <span className={`arrow ${isOpen ? "open" : ""}`}> <i className='bx bx-chevron-down'> </i></span>
      </div>
      {isOpen && (
        <div className="select-items">
          {options.map((option, index) => (
            <div className='select-item' key={index} onClick={() => selectOption(option)} data-cy={`select-item-${option}`}>
              <span className="items">{title}</span>
              <span className="items">{option}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
